export const PATIENT_SEARCH_REQUESTED = 'PATIENT_SEARCH_REQUESTED';
export const PATIENT_SEARCH_SUCCEED = 'PATIENT_SEARCH_SUCCEED';
export const PATIENT_SEARCH_FAILED = 'PATIENT_SEARCH_FAILED';

export const MESSAGES_PATIENT_SEARCH_REQUESTED = 'MESSAGES_PATIENT_SEARCH_REQUESTED';
export const MESSAGES_PATIENT_SEARCH_SUCCEED = 'MESSAGES_PATIENT_SEARCH_SUCCEED';
export const MESSAGES_PATIENT_SEARCH_FAILED = 'MESSAGES_PATIENT_SEARCH_FAILED';

export const PATIENT_CLEAR_SEARCH = 'PATIENT_CLEAR_SEARCH';
export const PATIENT_GOTO_SEARCH = 'PATIENT_GOTO_SEARCH';

export const PATIENT_SEARCH_MORE_REQUESTED = 'PATIENT_SEARCH_MORE_REQUESTED';
export const PATIENT_SEARCH_MORE_SUCCEED = 'PATIENT_SEARCH_MORE_SUCCEED';
export const PATIENT_SEARCH_MORE_FAILED = 'PATIENT_SEARCH_MORE_FAILED';

export const SEARCH_DOCTORS_INVITATION_REQUESTED = 'SEARCH_DOCTORS_INVITATION_REQUESTED';
export const SEARCH_DOCTORS_INVITATION_SUCCEED = 'SEARCH_DOCTORS_INVITATION_SUCCEED';
export const SEARCH_DOCTORS_INVITATION_FAILED = 'SEARCH_DOCTORS_INVITATION_FAILED';
